module.exports = __webpack_public_path__ + "static/media/Electric_Range.06bdff17.svg";